import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function AvisoLegalPage() {
  useEffect(() => {
    // SEO Meta Tags
    document.title = 'Aviso Legal - VaciadoPro Barcelona';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Aviso legal de VaciadoPro Barcelona. Información legal sobre el uso del sitio web y condiciones generales de contratación.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'aviso legal, condiciones uso, términos legales, VaciadoPro Barcelona');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/aviso-legal`);
    }

    // No indexar páginas legales
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-green-600 to-green-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Aviso Legal
              </h1>
              <p className="text-xl text-green-100">
                Información legal sobre nuestros servicios. 
                Conoce más sobre 
                <a href="/empresa" className="text-green-200 hover:text-white font-medium ml-1 mr-1">
                  nuestra empresa
                </a>
                y consulta todos 
                <a href="/servicios" className="text-green-200 hover:text-white font-medium ml-1">
                  nuestros servicios
                </a>.
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-lg p-8">
                
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Datos identificativos</h2>
                
                <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
                  <div className="space-y-3">
                    <p className="text-gray-700">
                      <strong>Denominación social:</strong> VaciadoPro Barcelona
                    </p>
                    <p className="text-gray-700">
                      <strong>Domicilio:</strong> Barcelona, España
                    </p>
                    <p className="text-gray-700">
                      <strong>Teléfono:</strong> +34 690 22 09 44
                    </p>
                    <p className="text-gray-700">
                      <strong>Email:</strong> info@vaciadopro.es
                    </p>
                    <p className="text-gray-700">
                      <strong>Sitio web:</strong> www.vaciadopro.es
                    </p>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Objeto</h3>
                <p className="text-gray-700 mb-6">
                  El presente aviso legal regula el uso del sitio web www.vaciadopro.es, del que es titular 
                  VaciadoPro Barcelona. La navegación por el sitio web atribuye la condición de usuario del mismo 
                  e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas 
                  en este Aviso Legal. Para más información sobre nuestros servicios, visite nuestra 
                  <a href="/servicios" className="text-green-600 hover:text-green-700 font-medium ml-1">
                    página de servicios
                  </a>.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Condiciones de uso</h3>
                <div className="space-y-4 mb-6">
                  <div className="border-l-4 border-green-500 pl-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Uso autorizado</h4>
                    <p className="text-gray-700">
                      El sitio web y sus servicios son de acceso libre y gratuito. No obstante, algunos servicios 
                      pueden estar sujetos a la previa suscripción o registro del usuario. Consulte nuestros 
                      <a href="/servicios" className="text-green-600 hover:text-green-700 font-medium ml-1">
                        servicios disponibles
                      </a> 
                      para más detalles.
                    </p>
                  </div>
                  
                  <div className="border-l-4 border-blue-500 pl-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Prohibiciones</h4>
                    <p className="text-gray-700">
                      Queda prohibido el uso del sitio web con fines ilícitos o no autorizados, que puedan dañar 
                      la imagen, los intereses y los derechos de VaciadoPro Barcelona o de terceros.
                    </p>
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Responsabilidades</h3>
                <p className="text-gray-700 mb-6">
                  VaciadoPro Barcelona no se hace responsable de los daños y perjuicios de toda naturaleza que 
                  pudieran deberse a la falta de disponibilidad o de continuidad del funcionamiento del sitio web, 
                  a la defraudación de la utilidad que los usuarios hubieren podido atribuir al sitio web, 
                  a la falibilidad del sitio web, y en particular, aunque no de modo exclusivo, a las fallas 
                  en el acceso a las distintas páginas web o a aquellas desde las que se preste el servicio.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Propiedad intelectual</h3>
                <p className="text-gray-700 mb-6">
                  Todos los contenidos del sitio web, incluyendo a título enunciativo pero no limitativo, 
                  textos, fotografías, gráficos, imágenes, iconos, tecnología, software, así como su diseño 
                  gráfico y códigos fuente, constituyen una obra cuya propiedad pertenece a VaciadoPro Barcelona, 
                  sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotación sobre los mismos.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Protección de datos</h3>
                <p className="text-gray-700 mb-6">
                  VaciadoPro Barcelona cumple con las directrices del Reglamento General de Protección de Datos (RGPD) 
                  y la Ley Orgánica de Protección de Datos Personales y garantía de los derechos digitales. 
                  Para más información, consulte nuestra Política de Privacidad.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Enlaces</h3>
                <p className="text-gray-700 mb-6">
                  En el caso de que en el sitio web se dispusiesen enlaces o hipervínculos hacia otros sitios 
                  de Internet, VaciadoPro Barcelona no ejercerá ningún tipo de control sobre dichos sitios y contenidos. 
                  En ningún caso VaciadoPro Barcelona asumirá responsabilidad alguna por los contenidos de algún enlace 
                  perteneciente a un sitio web ajeno.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Modificaciones</h3>
                <p className="text-gray-700 mb-6">
                  VaciadoPro Barcelona se reserva el derecho de efectuar sin previo aviso las modificaciones que 
                  considere oportunas en su portal, pudiendo cambiar, suprimir o añadir tanto los contenidos y 
                  servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados 
                  o localizados en su portal.
                </p>

                <h3 className="text-xl font-semibold text-gray-900 mb-4">Legislación aplicable</h3>
                <p className="text-gray-700 mb-6">
                  La relación entre VaciadoPro Barcelona y el usuario se regirá por la normativa española vigente 
                  y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Barcelona.
                </p>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
                  <div className="flex items-start">
                    <i className="ri-information-line text-yellow-600 text-xl mr-3 mt-1"></i>
                    <div>
                      <h4 className="text-lg font-semibold text-yellow-800 mb-2">Contacto</h4>
                      <p className="text-yellow-700 mb-2">
                        Para cualquier consulta relacionada con este aviso legal, puede contactarnos:
                      </p>
                      <div className="space-y-1">
                        <p className="text-yellow-700">📧 info@vaciadopro.es</p>
                        <p className="text-yellow-700">📞 +34 690 22 09 44</p>
                        <p className="text-yellow-700">
                          También puede usar nuestro 
                          <a href="/contacto" className="text-yellow-600 hover:text-yellow-800 font-medium ml-1">
                            formulario de contacto
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                  <p className="text-sm text-gray-500">
                    <strong>Última actualización:</strong> Diciembre 2024
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
